<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>上传管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-card class="box-card table">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <el-form-item label="选择图片">
            <div id="uploadBtn2" class="uploader uploader-warning"></div>
            <p>
              相对地址：
              <span id="relativeName"></span>
            </p>
            <p>
              文件大小：
              <span id="size"></span>
            </p>
            <p>
              图片内容：
              <img id="imgTarget">
            </p>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>



<script>
import "../../public/lib/cover/Cover3.0.min.css";
import "../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      ruleForm: {},
      rules: {}
    };
  },
  mounted() {
    /**大小图片前台处理，后台简单处理模式，上传成功后显示图片**/
    $("#uploadBtn2").uploader({
      url: "ws://www.gongjuji.net/common/upload",
      fileExts: "jpg;png",
      text: "剪切图片模式",
      more: false, //是否可以上传多个
      auto: true, //是否自动上传
      type: "dialog", //指定处理类型
      subfolder: "content", //默认后台处理简单模式 ，指定子文件夹
      coverParams: {
        title: "设置头像",
        targetWidth: 100,
        targetHeight: 100
      },
      onSuccess: function(data) {
        console.info(data)
        //添加到列表,每个图片上传成功都会触发
        $("#relativeName").text(data.relativeName);
        $("#size").text(data.curSize);
        $("#imgTarget").attr(
          "src",
          "http://www.gongjuji.net" + data.relativeName
        );
      }
    });
  }
};
</script>

